/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdSchoolEducationsSchooleducationid200,
  GetApiV1PersonIdSchoolEducationsSchooleducationid401,
  GetApiV1PersonIdSchoolEducationsSchooleducationid404,
  GetApiV1PersonIdSchoolEducationsSchooleducationid500,
  GetApiV1PersonIdSchoolEducationsSchooleducationidPathParams,
  GetApiV1PersonIdSchoolEducationsSchooleducationidQueryResponse,
} from "../../types/personStudentController/GetApiV1PersonIdSchoolEducationsSchooleducationid.ts";
import { schoolEducationDetailViewModelSchema } from "../schoolEducationDetailViewModelSchema.ts";

export const getApiV1PersonIdSchoolEducationsSchooleducationidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    schoolEducationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonIdSchoolEducationsSchooleducationidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdSchoolEducationsSchooleducationid200Schema =
  z.lazy(
    () => schoolEducationDetailViewModelSchema,
  ) as unknown as ToZod<GetApiV1PersonIdSchoolEducationsSchooleducationid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdSchoolEducationsSchooleducationid401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdSchoolEducationsSchooleducationid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdSchoolEducationsSchooleducationid404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdSchoolEducationsSchooleducationid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdSchoolEducationsSchooleducationid500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdSchoolEducationsSchooleducationid500>;

export const getApiV1PersonIdSchoolEducationsSchooleducationidQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdSchoolEducationsSchooleducationid200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdSchoolEducationsSchooleducationidQueryResponse>;
